import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import classes from '../../index.module.scss'
import { Price } from './popupBuyPackage/common/price'

export const UpgradeAccountBox = ({ oldPrice, price, exchangeRateAPI }) => {
  return (
    <Element
      style={{
        backgroundColor: '#FFFFFF',
        padding: '12px 12px 2px 12px',
        marginTop: 12,
      }}
      className={classes.content}
    >
      <Element className="fw600 mb2" style={{ fontSize: 14 }}>
        <Translate value="userManagement.upgradeAccount.UPGRADE" />
      </Element>
      <Price
        title="userManagement.buyPackage.PRICE"
        oldPrice={oldPrice}
        price={price}
        exchangeRateAPI={exchangeRateAPI}
        classNamePrice={classes.w44}
      />
    </Element>
  )
}
